import { Button } from "@mui/material";
import React from "react";
import { LoaderIcon } from "react-hot-toast";

function CustomButton({ label = "Submit", sx, disabled = false, ...rest }) {
  return (
    <>
      <Button
        fullWidth
        sx={{
          position: "fixed",
          zIndex: 100,
          bottom: 20,
          left: 0,
          right: 0,
          maxWidth: "400px",
          width: "90%",
          display: "flex",
          py: 1,
          margin: "auto",
          fontSize: 18,
          ...sx,
        }}
        type="submit"
        variant="contained"
        disabled={disabled}
        {...rest}
      >
        {disabled ? <><LoaderIcon />{' '} Processing... </> : label}
      </Button>

    </>
  );
}

export default CustomButton;
